<template>
  <div id="quickApplicationForm">
    <commonHeader :explain="explain" :title="pageTitle" />
    <div class="wrap">
      <!--锐捷员工基本信息-->
      <rjQuickBasicInformation
        v-if="applicationFormBasicType === 'rj' && (editRequestFlage || !editFlage)"
        ref="applicationFormBasic"
        :edit-echo-data="editEchoData"
        :set-cache-list="setCacheList"
        :update-form="updateForm"
      />
      <!--锐捷员工详情页基本信息-->
      <rjDetailsBasicInformation
        v-if="readOnlyMode && applicationFormBasicType === 'rj' && editRequestFlage"
        :edit-echo-data="editEchoData"
        :set-cache-list="setCacheList"
        :update-form="updateForm"
      />
      <qdQuickBasicInformation
        v-if="applicationFormBasicType === 'qd' && (editRequestFlage || !editFlage)"
        ref="applicationFormBasic"
        :set-cache-list="setCacheList"
        :update-form="updateForm"
      />
      <costAscription
        v-if="editRequestFlage || !editFlage" ref="applicationFormCost" :edit-echo-data="editEchoData"
        :other-data="otherData"
        :key="clickIndex"
        cost-ascription-type="quickType"
        @checkAllsmartOrderVOListCommand="handleSuccessAllsmartOrderVOList"
        @checkAllsmartOrderVOListSaveCommand="saveBtn"
      />
      <!-- 活动目录 -->
      <!-- <activityCatalogue ref="activityCatalogueRef"
        v-if="lang === 'zh-CN' && (!$route.query.activityCode || editEchoData)" :edit-echo-data="editEchoData"
        :cacheList="cacheList" :updateForm="updateForm" /> -->
      <!--活动附件-->
      <activityFile v-if="editRequestFlage || !editFlage" ref="activityFile" :edit-echo-data="editEchoData" />
      <div class="buttons">
        <el-button v-if="saveBtnShow" plain @click="handleSuccessAllsmartOrderSaveVOList">{{ this.$t('btn.SaveD') }}</el-button>
        <el-button type="primary" @click="submitBtn">{{ this.$t('btn.Submit') }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader';
import rjQuickBasicInformation from './component/quickApplicationForm/rjQuickBasicInformation';
import rjDetailsBasicInformation from '@/views/activitieList/component/activityDetails/basicInformation/rjBasicInformation.vue';
import qdQuickBasicInformation from './component/quickApplicationForm/qdQuickBasicInformation';
import costAscription from './component/newApplicationForm/costAscription';
import { hasAllsmartOrder, confirmAllsmartOrderTimeout } from '@/utils/allsmartOrderCheck';
import { confirmPrecheck, confirmBusiness, notifyDetectFailed } from '@/utils/exportComplianceDialog';
import activityFile from './component/newApplicationForm/activityFile';
import activityCatalogue from './component/newApplicationForm/activityCatalogue.vue';
import { newApplicationFormApi, activityRuleApi } from './service';
import {isNotEmpty, throttle, throttleAsync} from '../../utils/utils';

export default {
  name: 'NewApplicationForm',
  data () {
    return {
      pageTitle: this.$t('home.qa'),
      explain: {
        text: `${this.$t('notic.AppRule')}，`,
        content: this.$t('notic.AppRuleOne')
      },
      editFlage: false,
      editRequestFlage: false,
      readOnlyMode: false,
      applicationFormBasicType: 'rj',
      otherData: {},
      editEchoData: {},
      clickIndex: new Date().getTime(),
      lang: localStorage.getItem('lang') || 'zh-CN',
      cacheList: {},
      cform: {},
      timeOut: null,
      saveBtnShow: false
    };
  },
  components: {
    commonHeader,
    rjQuickBasicInformation,
    qdQuickBasicInformation,
    costAscription,
    activityFile,
    rjDetailsBasicInformation,
    activityCatalogue
  },
  computed: {},
  methods: {
    getApproveRule () {
      //  获取申请规则
      let isChannel = this.$store.state.userInfo.userType.indexOf('qd') === 0;
      let params = isChannel ? 'ChannelQuickApplication' : 'EmployeeQuickApplication';
      newApplicationFormApi.getApproveRule(params).then(res => {
        if (res.status === '200') {
          this.explain.content = res.data.fieldValue;
        }
      });
    },
    closeBtn () {
      this.$router.go(-1);
    },
    fileValidation () {
      let result = true;
      if (this.$refs.activityFile.fileList.length > 0) {
        let messageInfo = '';
        result = this.$refs.activityFile.fileList.every(item => {
          if (!((item.response && item.response.data[0].FID) || item.fileId)) {
            messageInfo = item.name ? `${item.name}${this.$t('file.FPdar')}` : this.$t('file.FPdaua');
          }
          return (item.response && item.response.data[0].FID) || item.fileId;
        });
        if (!result) this.$message.error(messageInfo);
      }
      return result;
    },
    costValidate () {
      let tableList = this.$refs.applicationFormCost.tableData;
      if (tableList.length < 1) {
        this.$message.error(this.$t('newApp.Attribute.psca'));
        return;
      }
      for (let i = 0; i < tableList.length; i++) {
        let item = tableList[i];
        // 如果是转申请，费用可以调整，但不能大于报备金额
        const reportType = this?.editEchoData?.marketActivity?.reportType ? this?.editEchoData?.marketActivity?.reportType * 1 : 0;
        if ((reportType > 0)) {
          let groupToatal = Number(item.activityCost) + Number(item.advertisingCost);
          if (groupToatal > item.reportApplyAmount) {
            this.$message.error(`${item.deptName}` + this.$t('newApp.Attribute.tao'));
            return;
          }
        }
        if (!tableList[i].financialSystemCode) {
          this.$message.error(this.$t('newApp.BasicInfo.psafs'));
          return;
        }
        if (!tableList[i].currencyCode) {
          this.$message.error(this.$t('newApp.BasicInfo.psac'));
          return;
        }
        if (!tableList[i].deptCode) {
          this.$message.error(this.$t('newApp.Attribute.pstcad'));
          return;
        }
        if (!tableList[i].expenseTypeCode) {
          this.$message.error(this.$t('newApp.Attribute.psaft'));
          return;
        }
        if (!tableList[i].subMarketCode) {
          this.$message.error(this.$t('newApp.Attribute.psams'));
          return;
        }
        if (tableList[i].deptCode.indexOf('000013') === 0 && !tableList[i].productLine) {
          this.$message.error(this.$t('newApp.activityInfo.psapl'));
          return;
        }
      }
      return true;
    },
    // 校验费用归属广告品费用是否有值无值自动请求接口查询
    async checkAllsmartOrderVOList (type) {
      const { dataList } = this.$refs.applicationFormCost.$refs.costAscriptionTable.tableData;
      dataList.forEach(item => {
        this.$refs.applicationFormCost.getDetailCommand(item, type);
      });
    },
    handleSuccessAllsmartOrderSaveVOList: throttle(function () {
      this.checkAllsmartOrderVOList('save');
    }, 1000),
    saveBtn (flage) {
      return new Promise((resolve, reject) => {
        let basicInfo = this.$refs.applicationFormBasic.getDraftData();
        console.log(this.editEchoData, 'this.editEchoData');
        let subData = {
          // 基础信息
          marketActivity: {
            ...basicInfo,
            submitType: 'quick_submit',
            reportType: this.editEchoData && this.editEchoData.marketActivity && this.editEchoData.marketActivity.reportType // （1-区域报备 2-行业报备）
          },
          submitType: 'quick_submit',
          // 产品线列表
          mactProductLineList: basicInfo.newProductlineSupplement ? basicInfo.newProductlineSupplement : [],
          // 议程列表
          mactAgendaList: basicInfo.industryAgenda ? basicInfo.industryAgenda : [],
          // 活动预计包含板块
          // mactModuleList: basicInfo.plate ? basicInfo.plate : [],
          // 客商列表
          // mactJoinCustomerList: this.$refs.customerInput ? this.$refs.customerInput.tableData : [],
          // 保存类型
          saveType: 1
        };
        // 客商列表
        // if (basicInfo.activityClassificationCode === 'AC_01' && !this.needOrganizer && this.applicationFormBasicType === 'rj') {
        //   subData.mactJoinCustomerList = this.$refs.customerInput.tableData ? this.$refs.customerInput.tableData : [];
        // }
        if (!this.needOrganizer || this.addCostEditFlag) {
          // 费用归属
          subData.mactExpenseBelongVOList = this.$refs.applicationFormCost.tableData.map(item => {
            item = {
              mactExpenseBelong: {
                ...item,
                activityCode: basicInfo.activityCode
              },
              activityExpenseDetails: item.activityExpenseDetails,
              advertiseExpenseDetails: item.advertiseExpenseDetails,
              allsmartOrderVOList: item.allsmartOrderVOList
            };
            if (this.$route.path === '/quickTransferApplication') {
              // 转申请则报备申请金额不能修改，则取后台返回的金额
              item.mactExpenseBelong.activityType = 1;
              item.mactExpenseBelong.reportType = this.editEchoData && this.editEchoData.marketActivity && this.editEchoData.marketActivity.reportType; // （1-区域报备 2-行业报备）
            }
            return item;
          });
          // 费用归属总计
          subData.marketActivity.totalCost = this.$refs.applicationFormCost.costTotal;
        } else {
          subData.mactExpenseBelongVOList = [];
        }
        // 文件列表
        if (!this.fileValidation()) return;
        if (this.$refs.activityFile.fileList.length > 0) {
          subData.attachFileList = this.$refs.activityFile.fileList.map(item => {
            return {
              fileId: item.response ? item.response.data[0].FID : item.fileId,
              fileName: item.name,
              activityCode: basicInfo.activityCode,
              sourceType: 'Activity'
            };
          });
        }
        this.$store.commit('setSubPageLoading', true);
        newApplicationFormApi.activityFormSave(subData).then(res => {
          this.$store.commit('setSubPageLoading', false);
          confirmBusiness(this, res).then(passed => {
            if (passed) {
              resolve();
              this.isOrdinaryJump = 1;
              this.$message.success(this.$t('general.SaveSucc'));
              if (flage !== 1) {
                this.$router.push('/drafts');
              }
            }
          });
        });
      });
    },
    handleSuccessAllsmartOrderVOList: throttle(async function () {
      // 礼品汇超时规则确认弹窗
      const tableData_ = this.$refs.applicationFormCost ? this.$refs.applicationFormCost.tableData : [];
      const confirmed = await confirmAllsmartOrderTimeout(this, hasAllsmartOrder(tableData_));
      if (!confirmed) return;
      // 基本信息数据
      let marketActivityData = {};
      // 提交表单对象
      let subData = {};
      if (this.$refs.applicationFormBasic) {
        // 如果表单不是详情页，就正常获取表单数据
        marketActivityData = await this.$refs.applicationFormBasic.getFormData();
        subData = {
          // 基础信息
          marketActivity: {
            ...marketActivityData,
            submitType: 'quick_submit'
          },
          // 产品线列表
          mactProductLineList: marketActivityData.newProductlineSupplement ? marketActivityData.newProductlineSupplement : [],
          // 议程列表
          mactAgendaList: marketActivityData.industryAgenda ? marketActivityData.industryAgenda : [],
          // 活动预计包含板块
          mactModuleList: marketActivityData.plate ? marketActivityData.plate : [],
          // 保存类型
          saveType: 2
        };
      } else {
        // 如果表单是详情页，就取后台返回的数据
        subData = this.editEchoData;
      }

      // 费用归属校验
      if ((!this.needOrganizer || this.addCostEditFlag) && !this.costValidate()) return;
      if (!this.needOrganizer || this.addCostEditFlag) {
        // 费用归属
        subData.mactExpenseBelongVOList = this.$refs.applicationFormCost.tableData.map(item => {
          item = {
            mactExpenseBelong: {
              ...item,
              activityCode: marketActivityData.activityCode
            },
            activityExpenseDetails: item.activityExpenseDetails,
            advertiseExpenseDetails: item.advertiseExpenseDetails,
            allsmartOrderVOList: item.allsmartOrderVOList
          };
          if (this.$route.path === '/quickTransferApplication') {
            // 转申请则报备申请金额不能修改，则取后台返回的金额
            item.mactExpenseBelong.activityType = 1;
            item.mactExpenseBelong.reportType = this.editEchoData && this.editEchoData.marketActivity && this.editEchoData.marketActivity.reportType; // （1-区域报备 2-行业报备）
          }
          return item;
        });
        // 费用归属总计
        subData.marketActivity.totalCost = this.$refs.applicationFormCost.costTotal;
      }

      // 客商列表
      subData.mactJoinCustomerList = this.$refs.customerInput ? this.$refs.customerInput.tableData : [];
      if (isNotEmpty(subData.mactJoinCustomerList)) {
        subData.mactJoinCustomerList.forEach(item => {
          item.phone = item.telephone;
        });
      }
      const reportType = this?.editEchoData?.marketActivity?.reportType ? this?.editEchoData?.marketActivity?.reportType * 1 : 0;
      const tableData = this.$refs.applicationFormCost ? this.$refs.applicationFormCost.tableData : [];
      const isSomeCostZero = tableData.some(item => {
        let groupToatal = Number(item.activityCost) + Number(item.advertisingCost);
        return groupToatal <= 0 && Number(item.reportApplyAmount) > 0;
      });
      // 如果是报备申请转快捷申请并且报备类型大于0，则判断费用归属中是否有费用为0的情况
      if (this.$route.path === '/quickTransferApplication' && reportType > 0) {
        if (isSomeCostZero) {
          // this.$confirm(this.$t('notic.costinfo'), this.$t('general.Hint'), {
          //   confirmButtonText: this.$t('btn.OK'),
          //   cancelButtonText: this.$t('btn.Cancel'),
          //   type: 'warning'
          // }).then(() => {
            this.handleAwaitSubmit(marketActivityData, subData);
          // }).catch(() => {
          // });
        } else {
          this.handleAwaitSubmit(marketActivityData, subData);
        }
      } else {
        this.handleAwaitSubmit(marketActivityData, subData);
      }
    }, 1000),
    // 待提交处理
    async handleAwaitSubmit (marketActivityData, subData) {
      // 文件列表
      if (!this.fileValidation()) return;
      if (this.$refs.activityFile.fileList.length > 0) {
        subData.attachFileList = this.$refs.activityFile.fileList.map(item => {
          return {
            fileId: item.response ? item.response.data[0].FID : item.fileId,
            fileName: item.name,
            activityCode: marketActivityData.activityCode,
            sourceType: 'Activity'
          };
        });
      }
      if (this.$store.state.newApplication.editFlag) {
        if (this.$store.state.newApplication.editFlag === 2) {
          // 品推编辑 编辑基本信息
          subData.saveType = 3;
        }
        if (this.$store.state.newApplication.editFlag === 3 || this.$store.state.newApplication.editFlag === 1) {
          // 3.驳回编辑 编辑被驳回的费用归属 || 1.编辑全部
          subData.saveType = 4;
        }
        if (this.$route.path === '/quickTransferApplication' && this.$route.query.metaActive !== '/activityQuery') {
          subData.saveType = 8; // 报备申请转活动申请
        }
        this.$store.commit('setSubPageLoading', true);
        newApplicationFormApi.activityFormSave(subData).then(res => {
          this.$store.commit('setSubPageLoading', false);
          confirmBusiness(this, res).then(passed => {
            if (passed) {
              this.isOrdinaryJump = 1;
              this.$message.success(this.$t('general.SubSucc'));
              if (this.$store.state.newApplication.editFlag > 0 && this.$route.query.metaActive) {
                this.$router.push({
                  path: '/activityDetails',
                  query: {
                    activityCode: this.$route.query.activityCode,
                    metaActive: '/activityQuery'
                  }
                });
                return;
              }
              this.$router.push('/activityQuery');
            }
          });
        });
      } else {
        if (this.$route.path === '/quickTransferApplication' && this.$route.query.metaActive !== '/activityQuery') {
          subData.saveType = 8; // 报备申请转活动申请
        }
        newApplicationFormApi.verificationActivity(subData).then(res => {
          confirmPrecheck(this, res, {
            originalBizId: (subData.marketActivity && subData.marketActivity.activityCode) || ''
          }).then(confirmed => {
            if (confirmed) {
              this.submitRequestCommand(subData);
            }
          });
        }).catch(() => {
          notifyDetectFailed(this);
        });
      }
    },
    submitRequestCommand (subData) {
      // 默认提交  全部驳回重新提交
      this.$store.commit('setSubPageLoading', true);
      const requestUrl = this.$route.path === '/quickTransferApplication' ? newApplicationFormApi.reportNewSubmit : newApplicationFormApi.activityFormSubimt;
      requestUrl(subData).then(res => {
        this.$store.commit('setSubPageLoading', false);
        confirmBusiness(this, res).then(passed => {
          if (passed) {
            this.isOrdinaryJump = 1;
            this.$message.success(this.$t('general.SubSucc'));
            if (this.$store.state.newApplication.editFlag > 0 && this.$route.query.metaActive) {
              this.$router.push({
                path: '/activityDetails',
                query: {
                  activityCode: this.$route.query.activityCode,
                  metaActive: this.$route.query.metaActive ? this.$route.query.metaActive : '/activityQuery'
                }
              });
              return;
            }
            let advertiseFlag = this.$refs.applicationFormCost.tableData.some(item => {
              return item.advertiseExpenseDetails && item.advertiseExpenseDetails.advertiseOrderDetails.length > 0;
            });
            if (advertiseFlag) {
              this.$confirm(this.$t('notic.tcuafc'), this.$t('general.Hint'), {
                confirmButtonText: this.$t('btn.OK'),
                showCancelButton: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showClose: false,
                type: 'warning'
              }).then(() => {
                this.$router.push('/activityQuery');
              }).catch(() => {
              });
            }
            this.$router.push('/activityQuery');
          }
        });
      });
    },
    async submitBtn () {
      this.checkAllsmartOrderVOList('submit');
    },
    arrayQuery (val, list, findKey) {
      return list.find(item => {
        return item[findKey] === val;
      });
    },
    getNewApplicationData () {
      newApplicationFormApi.getMarketActivityData(this.$route.query.activityCode).then(res => {
        if (res.status === '200') {
          this.editEchoData = res.data;
          this.editRequestFlage = true;
          this.clickIndex = new Date().getTime();
          this.$store.commit('newApplication/setIsUnionMarket', '0');
        }
      });
    },
    setCacheList (key, value) {
      this.$set(this.cacheList, key, value);
    },
    updateForm (form) {
      this.cform = { ...this.cform, ...form };
    }
  },
  created () {
    this.applicationFormBasicType = this.$store.state.userInfo.userType;
    if (this.$route.query.activityCode) {
      this.pageTitle = this.$t('btn.Edit');
      this.getNewApplicationData();
      this.editFlage = true;
      if (sessionStorage.getItem('applicationEditFlag')) {
        this.$store.commit('newApplication/setEditFlag', Number(sessionStorage.getItem('applicationEditFlag')));
      }
    }
  },
  mounted () {
    this.saveBtnShow = this.$route.path === '/quickApplicationForm' || this.$route.query.activeName === 'drafts';
    this.getApproveRule();
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('applicationEditFlag', this.$store.state.newApplication.editFlag);
    });
  },
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem('applicationEditFlag');
    this.$store.commit('newApplication/setEditFlag', 0);
    next();
  },

  watch: {
    cform: {
      handler (newVal, oldVal) {
        if (this.lang !== 'zh-CN') return;
        console.log(newVal);
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(() => {
          const form = {
            // 快捷申请活动分类
            quickActivityClassify: newVal.activityClassificationValue,
            // 快捷申请申请分类
            quickClassify: newVal.otherClassification
          };

          activityRuleApi.matchRule(form).then(res => {
            const val = res.data === null ? 'C' : res.data;
            this.$refs.applicationFormBasic.updateValue('activityLevel', val);
          });
        }, 1000);
      },
      deep: true
    }

  }
};
</script>
<style lang="scss" scoped>
#quickApplicationForm {
  width: 100%;

  >.wrap {
    >div {
      margin-bottom: 16px;
    }

    >.buttons {
      text-align: center;
    }
  }
}
</style>
